<template>
  <v-dialog
    v-if="requestDialog"
    v-model="requestDialog"
    width="570"
    persistent
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('investors.cancelSub') }}</b>
      </v-card-title>
      <v-card-text class="mt-5">
        <v-textarea
          id="reason"
          v-model.trim="reason"
          :counter="100"
          :error-messages="ReasonErrors"
          name="reason"
          :label="$t('investors.reason')+'*'"
          :placeholder="$t('investors.disconnectText')"
          required
          @input="$v.reason.$touch()"
          @blur="$v.reason.$touch()"
        />
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="close()"
        >
          {{ $t('globals.closeButton') }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading"
          @click="disconnect()"
        >
          {{ $t('investors.disconnectButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DISCONNECT_INVESTOR_MUTATION from '@/graphql/mutations/DisconnectInvestor.gql'
import { validationMixin } from 'vuelidate'
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'DisconnectDialog',
  mixins: [validationMixin],
  props: {
    connectionId: {
      type: Number,
      default() {
        return null
      }
    },
     showDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      reason: null,
      buttonClicked: null
    }
  },
  validations () {
    return {
      reason: {
        maxLength: maxLength(100),
      }
    }
  },
  computed: {
    requestDialog: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit("closeDisconnectDialog", this.buttonClicked);
      }
    },
    ReasonErrors (value) {
      const errors = []
     !this.$v.reason.maxLength &&
        errors.push(this.$t('investors.max100Field')) 
      return errors
    },
  },
  methods: {
    disconnect() {
      this.loading = true;
      this.$apollo.mutate({
        mutation: DISCONNECT_INVESTOR_MUTATION,
        variables: {
          id: this.connectionId,
          note: this.reason
        },
      }).then(data => {
        this.loading = false
        this.responseHandler(data)
        this.buttonClicked = 'disconnect'
        this.requestDialog = false
      }).catch(error => {
        this.errorHandler(error)
        this.loading = false
      })
    },
    close() {
      this.buttonClicked = 'close'
      this.requestDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
